module.exports = __webpack_public_path__ + "img/plane.4746690.jpg";